/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Quicktools_DescInputs */



/**
* | output |
* | --- |
* | "Enable and disable the tools found in the QuickTools panel located below the media player." |
*
* @param {Options_Quicktools_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_quicktools_desc = /** @type {((inputs?: Options_Quicktools_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Quicktools_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Activer et désactiver les outils du panneau QuickTools situé sous le lecteur multimédia.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktivieren und deaktivieren Sie die im QuickTools-Bereich unterhalb des Media-Players befindlichen Tools.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Abilita e disabilita gli strumenti presenti nel pannello QuickTools situato sotto il lettore multimediale.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Включайте и отключайте инструменты, расположенные на панели «Быстрые инструменты» под медиаплеером.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Habilite y deshabilite las herramientas que se encuentran en el panel Herramientas rápidas ubicado debajo del reproductor multimedia.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("启用和禁用媒体播放器下方“快速工具”面板中的工具。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディア プレーヤーの下にある QuickTools パネルにあるツールを有効または無効にします。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मीडिया प्लेयर के नीचे स्थित क्विक टूल्स पैनल में मौजूद टूल्स को चालू और बंद करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ative e desative as ferramentas encontradas no painel QuickTools, localizado abaixo do reprodutor de mídia.")
	return /** @type {LocalizedString} */ ("Enable and disable the tools found in the QuickTools panel located below the media player.")
});